import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import clone from 'lodash/clone'
import Redactor from '~/Common-Objects/RedactorSwitch'
export default class A extends Component {
    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
        this.updateHtmlValue = this.updateHtmlValue.bind(this)
    }

    onClick(event) {
        event.preventDefault()
    }

    updateHtmlValue(value) {
        var newObject = clone(this.props.elementData)
        newObject.content.value = value
        this.props.updateElement(newObject, this.props.path)
    }

    render() {
        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'a',
                this.props.localVariables
            )
        }

        var thisContent

        if (this.props.elementData.content && this.props.elementData.content.value && this.props.localVariables) {
            thisContent = this.props.elementData.content.value
            if (typeof thisContent === 'string' && thisContent.indexOf('localVariables_.') > -1) {
                var localVar = this.props.localVariables[thisContent.replace('_localVariables_.', '')]
                if (localVar) {
                    thisContent = localVar.value
                }
            }
        }

        if (this.props.localVariables.isHideMe && DragDropFunctions.formData?.options?.serve === 'clickButton') {
            if (!eleProps) eleProps = {}
            if (!eleProps.className) eleProps.className = 'dd-form-overlay'
            if (eleProps.className.indexOf('dd-form-overlay') === -1) eleProps.className += ' dd-form-overlay'
        }

        if (Array.isArray(thisContent)) {
            const baseHref = eleProps && eleProps.href
            return (
                <>
                    {thisContent.map((theOpt, index) => {
                        let theVal = theOpt
                        let theLab = theOpt
                        if (theOpt && typeof theOpt === 'object') {
                            theVal = theOpt.value
                            theLab = theOpt.label
                        }
                        const itemProps = { ...(eleProps || {}) }
                        if (
                            !baseHref ||
                            baseHref === '_REPEATVALUE_' ||
                            (typeof baseHref === 'string' && baseHref.indexOf('_REPEATVALUE_') > -1)
                        ) {
                            itemProps.href = theVal == null ? '' : String(theVal)
                        }
                        return (
                            <span key={'a-repeat-' + index} {...itemProps} onClick={this.onClick}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: theLab == null ? '' : String(theLab)
                                    }}
                                />
                            </span>
                        )
                    })}
                </>
            )
        }

        const isSelected = this.props.selectedElement.path === this.props.currentParentPath

        let redactorEle = null
        if (
            thisContent &&
            thisContent.length > 0 &&
            isSelected &&
            this.props.elementData?.content?.editableInline &&
            this.props.elementData?.content?.editable
        ) {
            const elementUuid = this.props?.tuuid?.tuuid || ''
            const favoriteColors = this.props.elementsData.globalVariables.favoriteColors || []
            const color = eleProps.style.color || null

            redactorEle = (
                <Redactor
                    isLandingPage={this.props.isLandingPage}
                    campaign={this.props.campaign}
                    content={thisContent}
                    updateContent={this.updateHtmlValue}
                    defaultFont={eleProps.style.fontFamily || ''}
                    defaultColor={color || ''}
                    globalColours={[]}
                    favoriteColors={favoriteColors}
                    elementsData={this.props.elementsData}
                    elementUuid={elementUuid}
                    overrideTools={['bold', 'italic', 'underline']}
                    allowParagraphs={false}
                    overridePlugins={[]}
                />
            )
        }

        return (
            <span {...eleProps} onClick={this.onClick}>
                {redactorEle != null && (
                    <>
                        {isSelected && redactorEle}
                        {!isSelected && (
                            <>
                                <span dangerouslySetInnerHTML={{ __html: thisContent }} />
                                {this.props.children}
                            </>
                        )}
                    </>
                )}
                {redactorEle == null && (
                    <>
                        <span dangerouslySetInnerHTML={{ __html: thisContent }} />
                        {this.props.children}
                    </>
                )}
            </span>
        )
    }
}
